import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97c1dcd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sort-option__name" }

import { SortType, TProductKeys } from '@/services';
import { useSortOption } from '@/composables';
import { parseCamelCase } from '@/utils';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortOption',
  props: {
    productKey: null,
    queryKey: null
  },
  setup(__props: any) {

const props = __props as {
  productKey: TProductKeys;
  queryKey: string;
};



const { sortUsage } = useSortOption(props.productKey, props.queryKey);

const iconClass = computed(() => {
  return sortUsage.value ? `sort-option__icon_type_${sortUsage.value}` : '';
});

function toggleSort() {
  sortUsage.value = sortUsage.value === SortType.ascending ? SortType.descending : SortType.ascending;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn sort-option",
    onClick: toggleSort
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["icon-sort sort-option__icon", _unref(iconClass)])
    }, null, 2 /* CLASS */),
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(parseCamelCase)(__props.productKey)), 1 /* TEXT */)
  ]))
}
}

})